<script>
export default {
    data() {
        return {
            content: "",
            showModal: false
        }
    },
    methods: {
        closeModal() {
            this.showModal = false;
            this.$emit('close-modal');
        }
    },
}
</script>

<style lang="scss" scoped>
    .modal{
        &.show{
            background-color: rgba(0,0,0,0.7);
            display: block;
            overflow-x: hidden;
            overflow-y: auto;
            .modal-dialog {
                -webkit-transform: translate(0,0);
                transform: translate(0,0);
                max-width: 80%;
                height: 80%;
                width: 80%;
                .modal-content{
                    width: 100%;
                    height: 100%;
                    box-shadow: 10px 10px 10px rgba(0,0,0,0.3);
                }
            }
        }
        .closeModal{
            color: rgba(255,255,255,0.7);
            text-shadow: 5px 5px 5px rgba(0,0,0,0.3);
            position: absolute;
            cursor: pointer;
            top: 5%;
            right: 5%;
        }
    }
</style>